import reducer from "./reducer";
export { default as NyApprovedConsents } from "./components/index";
export { default as myApprovedConsentsReducerName } from "./constants";
export default reducer;
